import classNames from 'classnames';
import React from 'react';

export type BREADCRUMB_TYPE = {
  title: string | undefined | string[];
  link: string | null;
};

interface BreadcrumbProps {
  className?: string;
  dataSet?: Array<BREADCRUMB_TYPE> | [];
  text?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const classes = classNames({
    [`${props.className}`]: !!props.className,
  });

  return (
    <nav
      data-testid="Breadcrumb"
      className={`${classes} bg-grey-light rounded-md w-full`}
    >
      <ol className="list-reset flex flex-row items-center text-s-14 flex-wrap font-medium sm:text-s-14 sm:inline">
        {props.dataSet?.map((ele, index) => {
          return (
            <span key={index} className="inline-flex items-center">
              <li
                className={`text-ellipsis whitespace-nowrap  overflow-hidden sm:max-w-[100px] ${
                  ele.link ? 'text-font-500' : 'text-font-200'
                }`}
              >
                <a
                  href={ele.link || '#'}
                  className={`${
                    ele.link ? 'text-font-500' : 'text-font-200'
                  } sm:text-s-12 `}
                >
                  {ele.title}
                </a>
              </li>
              {ele.link ? (
                <li>
                  <div className="p-2 sm:p-0 sm:px-2 sm:pt-1">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 11 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.14294 9L10 5L6.14294 1"
                        stroke="#9092A3"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 9L4.85708 5L1 1"
                        stroke="#9092A3"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </li>
              ) : null}
            </span>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumb.defaultProps = {
  dataSet: [{ title: 'Home', link: '/' }],
};

export { Breadcrumb };
